<div
  class="multi-select-container"
  [ngClass]="{ light: isLight, dark: !isLight }"
  (clickOutside)="handleClickOutside()"
>
  <div class="selected-items">
    @for (item of selectedItems; track item) {
      <div class="item-chip">
        <span>{{ item }}</span>
        <button type="button" class="remove-btn" (click)="removeItem(item)">&times;</button>
      </div>
    }
    <input
      type="text"
      [formControl]="searchControl"
      [placeholder]="placeholder | translate"
      (focus)="toggleDropdown()"
      (keydown)="onSearchKeydown($event)"
      [ngClass]="{ light: isLight, dark: !isLight }"
    />
  </div>

  @if (isDropdownOpen) {
    <div class="dropdown">
      @if (isLoading) {
        <div class="loading">{{ 'COMMON.LOADING' | translate }}</div>
      }
      @if (errorMessage) {
        <div class="error">{{ errorMessage }}</div>
      }
      <!-- Add new tag option -->
      @if (canAddNewTag && !isLoading) {
        <div
          class="dropdown-item add-new-item"
          role="button"
          (click)="addNewTag()"
          (keydown.enter)="addNewTag()"
          tabindex="0"
        >
          <strong>+ {{ 'LEARNING.ADD_NEW_TAG' | translate }}:</strong> "{{ currentSearchTerm }}"
        </div>
      }
      <!-- Existing tags -->
      @for (option of filteredOptions; track option) {
        <div
          class="dropdown-item"
          role="button"
          (click)="selectItem(option)"
          (keydown.enter)="selectItem(option)"
          tabindex="0"
        >
          {{ option }}
        </div>
      }
      @if (!isLoading && filteredOptions.length === 0 && !canAddNewTag) {
        <div class="no-results">
          {{ 'COMMON.NO_RESULTS_FOUND' | translate }}
        </div>
      }
    </div>
  }
</div>
